import classNames from 'classnames';
import React, { HTMLAttributes } from 'react';

import styles from './styles.module.scss';

const FlexRow = ({ className, ...rest }: HTMLAttributes<HTMLDivElement>) => (
  <div className={classNames(styles.FlexRow, className)} {...rest} />
);

export default FlexRow;
